// extracted by mini-css-extract-plugin
module.exports = {"loadingModal":"LoadingModal_loadingModal__3ZggO"};